import React from 'react';
import { useHistory } from "react-router-dom";
import { useFetch } from '../../../../hooks';
import { getDataByKey, getTranslation, renderData, getData } from '../../../../helpers';
import Button from '../../../../components/inputs/Button';
import Container from '../../../../components/Container';
import HeadBar from '../../../../modules/HeadBar';
import PageLoader from '../../../../components/PageLoader';
import ListItem from '../../../../components/ListItem';
import { ListWrap, ListTitle, ListTags, ListContainer } from '../../../../components/ListItem/styled';
import FooterBar from '../../../../modules/FooterBar';
import { StyledScanner, StyledScannerWrapper } from './styled';
import { Store } from '../../../../context/store';

const Scanner = () => {
    const history = useHistory();
    const { state: { user: { token } } } = Store();
    const { response, error, fetching, doFetch } = useFetch({
        url: '/scanner',
        method: 'GET'
    });

    const { doFetch: deleteTags } = useFetch({
        url: '/rpc/tf_delete_tags',
        method: 'POST'
    });

    const handleClickDeleteTags = async () => {
        try {
            const res = await deleteTags();
            if (res > 0) {
                doFetch();
            } else {
                console.log('error', res);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleClickAddTag = () => {
        history.push('/manage/scanner/add-tag');
    };

    const handleClickGoToScanner = () => {
        window.open(`intent://e-stado.net/finder#Intent;scheme=http;package=pl.microlabs.finder;S.token=${token};end;`);
    };

    const renderDataState = renderData({ data: getData(response, 'data'), error, fetching });
    const footerTranslation = getTranslation(response, 'footer');

    return (
        <StyledScanner>
            <HeadBar
                title={getDataByKey(response, 'title', '')}
                backTo="/manage"
            />
            <StyledScannerWrapper>
                <Container>
                    {
                        renderDataState({
                            fetching: () => (<PageLoader />),
                            error: () => (<div>{error.toString()}</div>),
                            data: data => (
                                data &&
                                data.map((tag, index) => (
                                    <ListItem
                                        key={`${tag.tag_id}${index}`}
                                        arrow={false}
                                        pointer={false}
                                    >
                                        <ListContainer>
                                            <ListWrap>
                                                <ListTitle>
                                                    {tag.headline}
                                                </ListTitle>
                                            </ListWrap>
                                            <ListWrap>
                                                <ListTags bold>
                                                    {tag.info}
                                                </ListTags>
                                            </ListWrap>
                                        </ListContainer>
                                    </ListItem>
                                ))
                            )
                        })
                    }
                    <FooterBar>
                        <Button transparent noMargin noPadding fullWidth onClick={handleClickDeleteTags}>
                            {footerTranslation && footerTranslation.c1ear}
                        </Button>
                        <Button transparent noMargin noPadding fullWidth onClick={handleClickAddTag}>
                            {footerTranslation && footerTranslation.add}
                        </Button>
                        <Button transparent noMargin noPadding fullWidth onClick={handleClickGoToScanner}>
                            {footerTranslation && footerTranslation.href}
                        </Button>
                    </FooterBar>
                </Container>
            </StyledScannerWrapper>
        </StyledScanner>
    );
}

export default Scanner;